import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RoleType } from "../../../types/Role";

const initialState: RoleType = {
    id: '',
    role: '',
};
export const roleSlice = createSlice({
    name: "roleForm",
    initialState,
    reducers: {
        setRoleData: (
            state, action: PayloadAction<RoleType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetRoleData: () => {
            return initialState
        }
    }
});
export const { setRoleData, resetRoleData } = roleSlice.actions;
export default roleSlice.reducer;